module.exports = require("lodash/isNull");